import { Node as SlateNode, Transforms as SlateTransforms } from 'slate';

import { SLATE_PROMPT_TAGS, SLATE_TEXT_FORMATS } from 'src/lib/slate';

// "instruction" and "variables" elements should be treated as voids
const VOID_TAGS = [SLATE_TEXT_FORMATS.PROMPT_INSTRUCTION, SLATE_TEXT_FORMATS.PROMPT_VARIABLE];

export const withPromptTags = (editor) => {
  const { normalizeNode, isVoid } = editor;

  editor.normalizeNode = (entry) => {
    const [node, path] = entry;

    // handle empty "prompt tags" and remove them
    if (SLATE_PROMPT_TAGS.includes(node.type)) {
      if (!SlateNode.string(node).trim()) {
        SlateTransforms.unwrapNodes(editor, { at: path });
      }
    }

    normalizeNode(entry);
  };

  // some elements should be treated as voids
  editor.isVoid = (element) => {
    if (VOID_TAGS.includes(element.type)) {
      return true;
    }

    return isVoid(element);
  };

  return editor;
};
